var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h3',[_vm._v("Successfully Logged Out!")]),_c('p',[_vm._v(" Redirecting to "),_c('b-link',{attrs:{"to":_vm.redirectRoute}},[_c('span',[_vm._v("home")])]),_vm._v(" in "+_vm._s(_vm.redirectTime)+" seconds ... ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }